import { useMutation } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';


export interface DeleteTreatmentsValuePayload{
    projectId:string;
   featureId:string;
   treatmentId:string;
   contextId:string;
   contextValues:string[];
}


const deleteTreatmentsValue = async (payload:DeleteTreatmentsValuePayload) => {
  try {
    const url = paths.deleteTreatmentsValue();
    const response = await axiosInstance.post(url, {input: payload});
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
  
};

export const useDeleteTreatmentsValue = () => {
  return useMutation(deleteTreatmentsValue);
}; 